<template>
		<g id="bird">
		<!-- 25BCCA 1A9DAE 0E687A -->
			<polyline 
				id="becco" 
				:fill="hasfill ? fill[2] : '#CCC'" points="598 62 546.87356 24 541 62 598 62"></polyline>

			<polyline 
				id="body" 
				:fill="hasfill ? fill[0] : '#CCC'" 
				points="514 218.280466 281 56 307.751929 283.192652 404.744661 319 514 218.280466"></polyline>
			
			<polyline
				id="wing-1" 
				:fill="hasfill ? fill[1] : '#CCC'" points="0 187.960275 280.112633 56 307 284 0 187.960275"></polyline>
			
			<polyline 
				id="wing-2" 
				:fill="hasfill ? fill[1] : '#CCC'" points="268 0 407 68.9517982 376.805217 122 280.55324 54.9336436 268 0"></polyline>
			
			<polyline 
				id="wing-3" 
				:fill="hasfill ? fill[2] : '#CCC'	" points="0 136.63338 266.452169 0 279 54.763053 49.0575901 163 0 136.63338"></polyline>
			
			<polyline 
				id="tale-top" 
				:fill="hasfill ? fill[1] : '#CCC'" points="213 483 405 318.851634 307.736773 283 213 483"></polyline>
			
			<polyline 
				id="tale-bottom" 
				:fill="hasfill ? fill[0] : '#CCC'" points="388.237346 667 405 318 213 482.130231 388.237346 667"></polyline>

			<polyline 
				class="excluded"
				id="neck-dark" 
				:fill="hasfill ? fill[2] : '#CCC'" points="407.1732 69 377 121.849163 514 217 407.1732 69"></polyline>
			
			<polyline 
				class="excluded"
				id="neck-light" 
				:fill="hasfill ? fill[1] : '#CCC'" points="544 25 513.001111 218 407 70.1795613 544 25"></polyline>
		</g>
	
</template>

<script>
import { TimelineLite, Back } from 'gsap'

export default {
	props: ['fill'],
	data() {
		return {

			controller: null,
			tween: null,
			scene: null
		}
	},
	computed: {
		hasfill: function() {
			return this.fill;
		}
	},
	mounted () {

		// this.controller = new ScrollMagic.Controller();
		
		// A personal note
		// const { phone, phoneBg } = this.$refs;
		
		this.tween = new TimelineLite;

		const el = document.querySelectorAll('#bird polyline:not(.excluded):not(#becco)');

		const becco = document.querySelectorAll('#becco');

		this.tween
		.from(el,.5, {
			// autoAlpha:0,
			transformOrigin:"top", 
			transformStyle:"preserve-3d"})
		.staggerFrom(el, .5, {
			cycle: {
				rotation: [-32,-40],
				scale: [.9,.8, .7]
			},
			ease:Back.easeIn
		}, 0.2)
		.from(becco,.35, {rotation: '180deg',transformOrigin: "left center"}, '-=.3')

		const scene2 = this.$scrollmagic.scene({
			// ID of element where animation starts
			triggerElement: '.h1-hero-home',
		
			// {0,0.5,1} - animations starts from {top,center,end} of window
			triggerHook: 0.6,
		
			// Duration of animation
			duration: 650
		})
		.setTween(this.tween)
			// Helpful tags for orientation on the screen
			// .addIndicators({ name: 'BIRD (duration: 300)' })

			// Add Scene to controller
			this.$scrollmagic.addScene(scene2)
	}
}
</script>